<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" class="scaling-svg">
      <g data-name="Icon_payment" transform="translate(1.167 2.917)">
        <path
          d="M1.454,2.677a.417.417,0,0,1,.089.283.355.355,0,0,1-.089.255.325.325,0,0,1-.244.091.41.41,0,0,1-.328-.134.6.6,0,0,1-.114-.4H0a1.084,1.084,0,0,0,.264.761,1.167,1.167,0,0,0,.763.339v.279a.181.181,0,1,0,.362,0V3.878a1.059,1.059,0,0,0,.672-.287.856.856,0,0,0,.248-.636.916.916,0,0,0-.077-.394.9.9,0,0,0-.214-.287,1.488,1.488,0,0,0-.326-.219q-.187-.1-.4-.187a.969.969,0,0,1-.308-.189.373.373,0,0,1-.1-.269.38.38,0,0,1,.082-.26.3.3,0,0,1,.235-.1.3.3,0,0,1,.26.128.621.621,0,0,1,.091.365h.77A1.06,1.06,0,0,0,2.089.834,1.011,1.011,0,0,0,1.436.49V.181a.181.181,0,1,0-.362,0v.3A1.115,1.115,0,0,0,.381.772a.838.838,0,0,0-.26.633A.95.95,0,0,0,.194,1.8a.851.851,0,0,0,.21.285A1.433,1.433,0,0,0,.729,2.3q.189.093.412.185A.831.831,0,0,1,1.454,2.677Z"
          transform="translate(4.667 1.75)"
        />
        <path
          d="M10.8,8H1.2A1.174,1.174,0,0,1,0,6.857V1.143A1.174,1.174,0,0,1,1.2,0h9.6A1.174,1.174,0,0,1,12,1.143V6.857A1.174,1.174,0,0,1,10.8,8Zm-9-6.857a.587.587,0,0,0-.6.571V6.285a.587.587,0,0,0,.6.571h8.4a.587.587,0,0,0,.6-.571V1.714a.587.587,0,0,0-.6-.571Z"
          transform="translate(-0.167 0.083)"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PaymentsIcon extends Vue {}
</script>

<style>
</style>
